import * as React from "react";
type Props = {
  className?: string,
};
function SvgLoseWeight({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-LoseWeight"
      className={className}
    >
      <path
        d="M39.7046 5H8.29543C6.75158 5 5.5 6.25158 5.5 7.79543V39.2046C5.5 40.7484 6.75158 42 8.29543 42H39.7046C41.2486 42 42.5001 40.7484 42.5001 39.2046V7.79543C42.5001 6.25158 41.2486 5 39.7046 5Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.4933 22.9691H29.743C29.743 19.7949 27.1746 17.2264 24.0067 17.2264C20.8325 17.2264 18.2641 19.7949 18.2641 22.9691H11.5137C11.5137 16.0674 17.105 10.4761 24.0067 10.4761C30.9021 10.4761 36.4933 16.0674 36.4933 22.9691Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0068 10.4761V13.2142"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.8376 15.2434L30.9014 17.1797"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9854 15.2434L16.9216 17.1797"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7725 15.2434L22.1624 17.6026"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgLoseWeight;
